module.exports = __webpack_public_path__ + "fa2f6fa97a2332988576fe54f7008829.jpg";